module.exports = __webpack_public_path__ + "static/img/chat3.00474a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleDan/chat3.png
// module id = hcTl
// module chunks = 1